<script setup lang="ts">
import {ref, nextTick} from "vue";
import {VideoService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import AddSingleVideo from "components/dialog/record/inner/AddSingleVideo.vue";
import {WarningFilled} from "@element-plus/icons-vue";

let player: Aliplayer;
let sectionId = 0;
const visible = ref(false);
const oldVideoId = ref("")
const addSingleVideo = ref<InstanceType<typeof AddSingleVideo>>();
// 已上传
const uploaded = ref(false)
// 转码成功
const transformComplete = ref(false);

const emit = defineEmits(['onSubmit', 'onPreviewVideo']);

const initVideoPlayer = async () => {
  try {
    const statusRes = await VideoService.getVideoStatus({
      video_id: oldVideoId.value
    })
    if (statusRes.data.code === 200) {
      if (statusRes.data.data === 1) {
        transformComplete.value = true
        await nextTick()
        // 转码完成，获取播放凭证
        await getAuth()
      } else {
        // 转码中
        transformComplete.value = false
      }
    } else {
      ElNotification.error({
        title: '获取视频转码状态失败',
        message: statusRes.data.msg,
        type: 'error',
      })
    }
  } catch (error) {
    console.warn(error)
  } finally {
  }
}

const getAuth = async () => {
  try {
    const res = await VideoService.getPlayAuth({
      video_id: oldVideoId.value
    })
    if (res.data.code === 200) {
      await nextTick(() => {
        const playerOption = {
          id: "uploaded-video-container",
          width: "100%",
          height: "600px",
          autoplay: true,
          vid: oldVideoId.value,
          playauth: res.data.data?.PlayAuth,
          cover: res.data.data?.CoverURL,
          encryptType: 1,
        }
        player = new Aliplayer(playerOption)
      })
    } else {
      ElNotification.error({
        title: '获取播放凭证失败',
        message: res.data.msg,
        type: 'error',
      })
    }
  } catch (error) {
    console.warn(error)
  } finally {
  }
}

const disposeVideo = () => {
  if (player) {
    player.dispose();
  }
}

const show = (_videoId: string, _sectionId: number) => {
  oldVideoId.value = _videoId
  sectionId = _sectionId
  visible.value = true;
  if (player) {
    disposeVideo()
  }
  if (!_videoId) {
    // 视频id为空，应该上传视频
    uploaded.value = false
    // 同时无需调用查看转码状态接口 直接置为未转码
    transformComplete.value = false
  } else {
    // 视频id不为空，应该查看转码状态
    uploaded.value = true
    initVideoPlayer()
  }
}

const hide = () => {
  visible.value = false;
  disposeVideo()
  addSingleVideo.value?.stopUpload()
}

const onSureSubmit = () => {
  if (addSingleVideo.value && addSingleVideo.value.isUploading()) {
    return ElNotification.warning({
      title: '注意',
      message: '请等待视频上传完成',
      type: 'warning',
    })
  }
  const videoId = addSingleVideo.value?.getVideoId()
  if (!videoId) {
    return ElNotification.warning({
      title: '注意',
      message: '请提交新视频',
      type: 'warning',
    })
  }
  emit("onSubmit", sectionId, videoId)
}

const onPreviewVideo = (videoId: string) => {
  emit("onPreviewVideo", videoId)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog @close="hide" title="章节视频" width="40%" v-model="visible" align-center :close-on-click-modal="false">
    <div id="uploaded-video-container" ref="playerCon" v-if="uploaded && transformComplete">
    </div>
    <div class="text-1.25rem" v-else-if="uploaded && !transformComplete">
      <el-icon><WarningFilled style="color: #f67139" /></el-icon>
      <span class="ml-.5rem">章节视频已上传，正在转码中</span>
    </div>
    <div class="text-1rem flex items-center" v-else-if="!uploaded">
      <el-icon><WarningFilled style="color: #f67139" /></el-icon>
      <span class="ml-.5rem">暂未上传视频</span>
    </div>
    <div class="flex items-center mt-1rem" v-if="visible">
      <add-single-video ref="addSingleVideo" @on-preview-video="onPreviewVideo"/>
    </div>
    <div class="w-full mt-1rem">
      <el-button type="primary" class="mx-auto" @click="onSureSubmit">
        确认提交
      </el-button>
      <el-button @click="hide">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
</style>
